import { InfoCircledIcon } from "@radix-ui/react-icons";
import { Callout } from "@radix-ui/themes";

const ChromeUsageReminder = (): JSX.Element => {
  return (
    <div className="absolute top-2 left-1/2 transform -translate-x-1/2">
      <Callout.Root color="red" size="1" variant="soft" className="z-10">
        <Callout.Icon>
          <InfoCircledIcon />
        </Callout.Icon>
        <Callout.Text>
          For the best experience and to avoid potential issues, please use
          Chrome.
        </Callout.Text>
      </Callout.Root>
    </div>
  );
};

export default ChromeUsageReminder;
